import React from "react";
import { LoaderLogo, LoaderLogoDohod } from "@/assets/icons";
import { useServiceType } from "@/utils/hooks/useServiceType";

const LoaderLogoByService = () => {
  const { isSravniDohod } = useServiceType();

  if (isSravniDohod) {
    return <LoaderLogoDohod />;
  }

  return <LoaderLogo />;
};

export default LoaderLogoByService;
